export default __webpack_public_path__ + "static/lviv-it-cluster-logo-fe97ab204fae0c474e2760f6834ed947.svg";